// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("./geomanist-ultra-webfont.woff");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, "/* Generated by Font Squirrel (https://www.fontsquirrel.com) on October 7, 2016 */\r\n\r\n\r\n\r\n@font-face {\r\n    font-family: \"geomanist\";\r\n    src: local('Geomanist Ultra'), url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ") format(\"woff\");\r\n    font-weight: 900;\r\n    font-style: normal; \r\n    font-display: swap;\r\n}", ""]);
// Exports
module.exports = exports;
